import { forwardRef } from 'react';
import { TrellisBaseToolbar } from './BaseToolbar';
import { jsx as _jsx } from "react/jsx-runtime";
const HorizontalEdgeToolbar = (props, ref) => {
  return /*#__PURE__*/_jsx(TrellisBaseToolbar, Object.assign({
    iconUse: "edge",
    firstButtonRounding: 'top left',
    lastButtonRounding: 'top right'
  }, props, {
    forwardedRef: ref
  }));
};
export const TrellisHorizontalEdgeToolbar = /*#__PURE__*/forwardRef(HorizontalEdgeToolbar);
TrellisHorizontalEdgeToolbar.displayName = 'HorizontalEdgeToolbar';
export default TrellisHorizontalEdgeToolbar;